<main class="modal">
  <a
    class="link-cancel"
    mat-icon-button
    matTooltip="Cancelar"
    (click)="cancel()"
    matTooltipPosition="left"
  >
    <mat-icon>close</mat-icon>
  </a>
  <div style="overflow-y: hidden; height: calc(100vh - 15rem)">
    <div style="overflow-y: auto; height: 100%">
      <form [formGroup]="formGroup" (ngSubmit)="submit(data.cpf)">
        <div mat-dialog-content class="content">
          <mat-card>
            <div class="row">
              <h5>Extrato por cliente</h5>
              <div class="col-12 col-sm-12">
                <mat-form-field *ngIf="!data.cpf" class="customer-autocomplete">
                  <mat-label>CPF ou Nome do Cliente</mat-label>
                  <mat-chip-list #chipList>
                    <mat-chip
                      *ngFor="let customer of selectedCustomers"
                      [selectable]="false"
                      [removable]="true"
                      (removed)="removeCustomer(customer)"
                    >
                      {{ customer.cpf | mask: '000.000.000-00' }} {{ customer.name }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input
                      matInput
                      #customerInput
                      [formControl]="customerControl"
                      formControlName="customersInput"
                      [matAutocomplete]="auto"
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    />
                  </mat-chip-list>
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                    <mat-option
                      *ngFor="let customer of filteredCustomers | async"
                      [value]="customer"
                    >
                      {{ customer.cpf | mask: '000.000.000-00' }} {{ customer.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-error
                  *ngIf="!data.cpf && customerInvalid"
                  style="padding-bottom: 9px; font-size: 12px"
                  >Campo deve ser preenchido</mat-error
                >
                <div *ngIf="data.cpf">
                  <ul class="heroes" style="padding-inline-start: 15px">
                    <li>
                      <span class="badge"><b>CPF</b></span
                      >: {{ data.cpf | mask: '000.000.000-00' }}
                    </li>
                    <li>
                      <span class="badge"><b>NOME</b></span
                      >: {{ data.fullName }}
                    </li>
                  </ul>
                </div>

                <mat-form-field>
                  <input
                    matInput
                    formControlName="beginDate"
                    placeholder="Data Inicial"
                    type="date"
                    (change)="changeBeginDate($event, data.cpf)"
                  />
                  <!-- <mat-error *ngIf="!data.cpf && formGroup.controls.beginDate?.invalid">
                    {{ errorsService.messageErrorFor(formGroup.controls.beginDate) }}
                  </mat-error> -->
                </mat-form-field>
                <mat-error style="padding-bottom: 9px; font-size: 12px" *ngIf="beginDateInvalid"
                  >Campo deve ser preenchido</mat-error
                >
                <mat-form-field>
                  <input
                    matInput
                    formControlName="endDate"
                    placeholder="Data Final"
                    type="date"
                    (change)="changeEndDate($event, data.cpf)"
                  />
                  <!-- <mat-error *ngIf="!data.cpf && formGroup.controls.endDate?.invalid">
                    {{ errorsService.messageErrorFor(formGroup.controls.endDate) }}
                  </mat-error> -->
                </mat-form-field>
                <mat-error style="padding-bottom: 9px; font-size: 12px" *ngIf="endDateInvalid"
                  >Campo deve ser preenchido</mat-error
                >
              </div>
            </div>
          </mat-card>
        </div>
        <div mat-dialog-actions>
          <div class="actions">
            <button mat-button class="btn-submit-dark">Exportar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</main>
